import script from "./PhoneEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneEntry.vue?vue&type=script&setup=true&lang=js"

import "./PhoneEntry.vue?vue&type=style&index=0&id=56d1b65d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d1b65d"]])

export default __exports__